/**
 * @author Maxime Mustarda <maxime@inarix.com>
 * @file BuyLicenseBtn.tsx
 * @desc Created on Thu May 15 2025 20:56:31
 * @copyright All rights reserved @ Inarix
 */
import { Button } from "@mui/material";
import { Mail } from "@mui/icons-material";
import { SALES_EMAIL } from "../../config";
import { useTranslation } from "react-i18next";
import customFilterStyles from "../customFilterComponent/customFiltersStyles";
import SearchComponent from "../customFilterComponent/searchComponent";
import { DevicesStyles } from "../userDevices/DevicesStyles";
import { CustomFilterButton } from "../customFilterComponent/customFilterButton";
import { useLicenseColumns } from "./LicenceColumns";
import { useDispatch, useSelector } from "react-redux";
import useLicensesFilters from "./ExtraFilters";
import {
  LicensesFilters,
  setFilterModel,
  setPreselectedFilterField,
  setShowFilterForm,
} from "../../redux/slices/licenses/licenseList";
import { ThunkDispatch } from "@reduxjs/toolkit";
import { FC, useState } from "react";
import { useGridApiRef } from "@mui/x-data-grid-pro";
import { statusLicensesOptions } from "./StatusOptions";

type BuyLicensesParams = {
  apiRef: ReturnType<typeof useGridApiRef>;
};
const SetActions = () => {
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();

  return {
    /// custom filter component
    setFilterModel: (filterModel: any) => {
      dispatch(setFilterModel(filterModel));
    },

    setShowFilterForm: (show: boolean) => {
      dispatch(setShowFilterForm(show));
    },

    setPreselectedFilterField: (field: string | null) => {
      dispatch(setPreselectedFilterField(field));
    },
  };
};
export const BuyLicenseBtn: FC<BuyLicensesParams> = ({ apiRef }) => {
  const [t] = useTranslation("global");
  const dispatch = useDispatch();
  const { setFilterModel, setShowFilterForm, setPreselectedFilterField } =
    SetActions();

  const { filter } = useLicensesFilters();
  const filters = filter();

  const { licenseColumns, licensesRows } = useLicenseColumns(t, dispatch);
  const { filterModel, showFilterForm, preselectedFilterField } =
    useSelector(LicensesFilters);
  const [quickFilterValue, setQuickFilterValue] = useState("");

  const handleQuickFilterChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.value;
    setQuickFilterValue(value);

    if (apiRef.current) {
      apiRef.current.setQuickFilterValues(value ? [value] : []);
    }
  };

  const hasNoData = licensesRows.length === 0;

  return (
    <div className={"panel-container-licenses"}>
      <div className="button-buy-licenses">
        <Button
          sx={{ textTransform: "none" }}
          variant="contained"
          onClick={(e) => {
            window.location.href = `mailto:${SALES_EMAIL}`;
            e.preventDefault();
          }}
          endIcon={<Mail />}
        >
          {t("licenses.buyMore")}
        </Button>
      </div>

      <div
        style={{
          ...customFilterStyles.filterContainer,
          marginRight: "60px",
          marginTop: "20px",
        }}
      >
        <SearchComponent
          t={t}
          quickFilterValue={quickFilterValue}
          handleQuickFilterChange={handleQuickFilterChange}
        />
        <div style={DevicesStyles.containerFilterButon}>
          <CustomFilterButton
            t={t}
            isDisabled={false}
            loadingsValues={false}
            filterModel={filterModel}
            setShowFilterForm={setShowFilterForm}
            showFilterForm={showFilterForm}
            setPreselectedFilterField={setPreselectedFilterField}
            preselectedField={preselectedFilterField}
            columnsTable={filters.concat(licenseColumns) as any}
            setFilterModel={setFilterModel}
            handleApplyFilters={() => {}}
            hasNoData={hasNoData}
            sectionName={"licenses"}
            statusOptions={statusLicensesOptions(t)}
          />
        </div>
      </div>
    </div>
  );
};
